import { Container, Row } from 'react-bootstrap';
import Blockquote from './Blockquote';

const BlockquoteDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Blockquote>
            <span>
              Note: Since you are age 55 by December 31 of this year, you're
              eligible for the catch-up contribution which means the 2023 IRS
              maximum contribution is $4,450 for individuals or $8,100 for
              families.
            </span>
          </Blockquote>
        </Row>
      </Container>
    </Container>
  );
};

export default BlockquoteDemo;
